<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>William worked as an engineering designer in Pennsylvania, Florida, Minnesota and Oregon. In the spring of 2007, he retired intending to write a practical environmental engineering CAD drawing production guide. However, he chose to pursue his dream of writing fiction instead. For over twenty-years, William’s daughter has either leased or owned horses. And has competed in both dressage and western riding matches. She is also a riding instructor for young adults and kids. Her involvement with horses has provided him with an extensive background on their behaviour and nature. When not writing, William enjoys drawing, painting and photography.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0d4543d4